import { _CollectionType, SupportedMediaType } from "apollo/graphql.generated";

import { CollectionUseForm } from "./context";

export const getPreviewImageUrl = (
  form: CollectionUseForm
): {
  previewMediaUrl: string | null;
  previewMediaType: SupportedMediaType | null;
} => {
  const { metadata, contract } = form.values;
  const hasSeriesLogoImage =
    [_CollectionType.Series, _CollectionType.GenerativeSeries].includes(
      form.values.collectionType
    ) &&
    contract.type === "new" &&
    contract.data.collectionLogoImage;

  if (hasSeriesLogoImage) {
    return {
      previewMediaUrl: contract.data.collectionLogoImage,
      previewMediaType: SupportedMediaType.IMAGE,
    };
  }

  if (metadata.mediaType === "zip") {
    return {
      previewMediaUrl: null,
      previewMediaType: null,
    };
  }

  return {
    previewMediaUrl: metadata.mediaUrl,
    previewMediaType: metadata.mediaType,
  };
};
